import { useNuxtApp, useRuntimeConfig } from "#imports";
export function useVoixConfig() {
  const getVoixConfig = () => {
    const { $voix } = useNuxtApp();
    return $voix.options;
  };
  const getCurrentEnvironmentConfig = () => {
    const config = useRuntimeConfig();
    return config.public;
  };
  const getCurrentDomain = () => {
    const config = useRuntimeConfig();
    return config.public.voixDomain;
  };
  return {
    getVoixConfig,
    getCurrentEnvironmentConfig,
    getCurrentDomain
  };
}
